module.exports = __webpack_public_path__ + "img/WorkSans-ExtraBold.a91f0e3.svg";